var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7425 13.2427L5.25727 4.75738",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7427 4.75738L5.25745 13.2427",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_965_11377",
    x1: 15.4251,
    y1: 13.2679,
    x2: 16.3994,
    y2: 7.46074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#624CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A459FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_965_11377",
    x1: 16.7663,
    y1: 3.00797,
    x2: 15.8896,
    y2: 2.09194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#624CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A459FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhite);
export default __webpack_public_path__ + "static/media/closeWhite.0e4fcc836edf9751f66d19a068d9bdea.svg";
export { ForwardRef as ReactComponent };